import {
  BsLightningChargeFill,
  BsScissors,
  BsShop,
  BsCarFrontFill,
  BsPersonBoundingBox,
} from "react-icons/bs";
import "../styles/targetaudience.css";

function TargetAudience() {
  const examples = [
    { label: "villanyszerelők", icon: <BsLightningChargeFill size={24} /> },
    { label: "fodrászok", icon: <BsScissors size={24} /> },
    { label: "kisállateledel boltok", icon: <BsShop size={24} /> },
    { label: "autószervizek", icon: <BsCarFrontFill size={24} /> },
    {
      label: "más helyi szolgáltatók",
      icon: <BsPersonBoundingBox size={24} />,
    },
  ];

  return (
    <section id="target-audience" className="target-audience-section">
      <div className="container pb-4">
        <h2 className="target-audience-title">Kikkel dolgozom együtt?</h2>
        <p className="target-audience-description">
          Olyan kisvállalkozóknak segítek, akik már működő vállalkozással
          rendelkeznek – jellemzően fizikai üzlettel vagy jól behatárolható
          szolgáltatással egy adott városban.
        </p>

        <div className="container mt-4">
          <div className="row justify-content-center align-items-center text-center text-md-start">
            {/* Left Column: Cards */}
            <div className="col-12 col-md-6 mb-4 mb-md-0">
              <div className="row">
                {examples.map((item, index) => (
                  <div key={index} className="col-6 mb-4">
                    <div className="card h-100 shadow-sm border-0 text-center">
                      <div className="card-body d-flex flex-column align-items-center justify-content-center">
                        <div className="mb-2" style={{ color: "#2c2f36" }}>
                          {item.icon}
                        </div>
                        <h6
                          className="card-title mb-0"
                          style={{ color: "#2c2f36", fontWeight: 600 }}
                        >
                          {item.label}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <img
                src="/images/target.webp"
                alt="Célközönség példák: villanyszerelők, fodrászok, kisállateledel boltok, autószervizek"
                className="target-audience-image img-fluid"
                loading="lazy"
                decoding="async"
                width="900"
                height="600"
              />
            </div>
          </div>
        </div>

        <p className="target-audience-footer mt-4">
          Ha nem vagy benne biztos, hogy neked tudok-e segíteni, írj rám –
          gyorsan válaszolok, és őszintén megmondom, ha nem én vagyok a
          megfelelő ember.
        </p>
      </div>

      <div className="text-center mt-2">
        <a href="#contact" className="btn btn-light btn-lg px-4 target-button">
          Érdekel!
        </a>
      </div>

      <div className="curved-divider">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#f5f5f5"
            d="M0,70 C360,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default TargetAudience;
